import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from 'src/app/shared/components/confirmation-modal/confirmation-modal.component';
import { IdentityModel } from 'src/app/shared/models/identity.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { RedirectService } from 'src/app/shared/services/redirect.service';
import { SelfManageService } from 'src/app/shared/services/self-manage.service';
import {StaticResourcesService} from "../../shared/services/static-resources.service";

@Component({
  selector: 'app-identity',
  templateUrl: './identity.component.html',
  styleUrls: ['./identity.component.scss']
})
export class IdentityComponent implements OnInit {

  identity:IdentityModel;
  hideRemoveIdentityButton: boolean = true;

  constructor(
    private selfManageService: SelfManageService,
    private bsModalService: BsModalService,
    private redirectService: RedirectService,
    public translate: TranslateService,
    private alertService: AlertService,
    private staticResourcesService: StaticResourcesService
  ) { }

  ngOnInit(): void {
    this.fetchConfigs();
    this.getIdentityDetails();
  }

  fetchConfigs() {
    this.staticResourcesService.fetchConfigs().subscribe(config => {
      this.hideRemoveIdentityButton = config?.hideRemoveButtonAction;
    });
  }

  getIdentityDetails(){
    this.selfManageService.fetchDetails()
      .subscribe(
        resp => {
          this.identity = resp;
          if(this.identity.error.length > 0) {
            this.alertService.error(this.identity.error)
          }
        },
        error => {
          debugger;
          console.log(error);
        }
      );
  }

  getLoadedIdentity(){
    return this.identity;
  }

  onUnblockIdentity(){
    var title = 'Are you sure you want to unblock this identity?';
    this.translate.get('POP-UPS.UNBLOCK_IDENTITY_TITLE', {value: title}).subscribe((res: string) => {
      title = res;
    });

    var body = 'You cannot undo this action.';
    this.translate.get('POP-UPS.UNBLOCK_IDENTITY_MESSAGE', {value: body}).subscribe((res: string) => {
      body = res;
    });

    const modal = this.bsModalService.show(ConfirmationModalComponent);
    (<ConfirmationModalComponent>modal.content).showConfirmationModal(
        title,
        body
    );

    (<ConfirmationModalComponent>modal.content).onClose.subscribe(result => {

      if (result === true) {
          // when pressed Yes
          this.unblockIdentity();
      } else if(result === false) {
          // when pressed No
      } else {
          // When closing the modal without no or yes
      }
    });
  }


  unblockIdentity(){
    this.selfManageService.unblock()
      .subscribe(
        resp => {
          if (resp.error.errorCode != 0) {
            var errorMessage = 'An error occurred while unblocking identity.';
            this.translate.get('ERROR.UNBLOCK_IDENTITY', {value: errorMessage}).subscribe((res: string) => {
              errorMessage = res;
            });
            this.alertService.error(resp.error.errorDescription, errorMessage);
          } else {
            window.location.reload();
          }
        },
        error => {
          debugger;
          console.log(error);
        }
      );
  }

  onRemoveIdentity(){
    var title = 'Are you sure you want to remove this identity?';
    this.translate.get('POP-UPS.REMOVE_IDENTITY_TITLE', {value: title}).subscribe((res: string) => {
      title = res;
    });

    var body = 'You cannot undo this action.';
    this.translate.get('POP-UPS.REMOVE_IDENTITY_MESSAGE', {value: body}).subscribe((res: string) => {
      body = res;
    });

    const modal = this.bsModalService.show(ConfirmationModalComponent);
    (<ConfirmationModalComponent>modal.content).showConfirmationModal(
        title,
        body
    );

    (<ConfirmationModalComponent>modal.content).onClose.subscribe(result => {

      if (result === true) {
          // when pressed Yes
          this.removeIdentity();
      } else if(result === false) {
          // when pressed No
      } else {
          // When closing the modal without no or yes
      }
    });
  }

  removeIdentity(){
    this.selfManageService.remove()
      .subscribe(
        resp => {
          if (resp.error.errorCode != 0) {
            var errorMessage = 'An error occurred while removing identity.';
            this.translate.get('ERROR.REMOVE_IDENTITY', {value: errorMessage}).subscribe((res: string) => {
              errorMessage = res;
            });
            this.alertService.error(resp.error.errorDescription, errorMessage);
          } else {
            this.redirectService.redirectToSAMLLogout();
          }
        },
        error => {
          debugger;
          console.log(error);
        }
      );
  }
}
